import type {
  DashboardRecentTransactionsState,
  FinancialAccountTransaction,
} from '@brightside-web/desktop/feature/financial-accounts-core';

/** Dev override for V3 savings/spending dashboard recent-transactions panel. */
export type DashboardRecentTransactionsDevMode =
  | 'loading'
  | 'empty'
  | 'error'
  | 'list'
  | 'list-see-all';

export const DASHBOARD_RECENT_TRANSACTIONS_DEV_OPTIONS: readonly {
  readonly value: DashboardRecentTransactionsDevMode | null;
  readonly label: string;
}[] = [
  { value: null, label: 'Off (API)' },
  { value: 'loading', label: 'Loading' },
  { value: 'empty', label: 'Empty' },
  { value: 'error', label: 'Error' },
  { value: 'list', label: 'List (3)' },
  { value: 'list-see-all', label: 'List + See all' },
];

const _MOCK_TRANSACTIONS: readonly FinancialAccountTransaction[] = [
  {
    transactionId: 90001,
    createdDate: '2026-05-18T14:30:00.000Z',
    amount: '-24.99',
    description: 'Transfer to savings',
    statusCopyKey: 'TRANSACTION_STATUS_SETTLED',
    type: 'transfer',
    merchant: 'Brightside Transfer',
  },
  {
    transactionId: 90002,
    createdDate: '2026-05-17T09:15:00.000Z',
    amount: '150.00',
    description: 'Payroll deposit',
    statusCopyKey: 'TRANSACTION_STATUS_PENDING',
    type: 'credit',
    merchant: 'Acme Employer',
  },
  {
    transactionId: 90003,
    createdDate: '2026-05-16T18:45:00.000Z',
    amount: '-8.42',
    description: 'Coffee shop',
    statusCopyKey: 'TRANSACTION_STATUS_INITIATED',
    type: 'debit',
    merchant: 'Corner Cafe',
  },
  {
    transactionId: 90004,
    createdDate: '2026-05-14T11:00:00.000Z',
    amount: '-125.00',
    description: 'Utility payment',
    statusCopyKey: 'TRANSACTION_STATUS_SETTLED',
    type: 'debit',
    merchant: 'City Utilities',
  },
  {
    transactionId: 90005,
    createdDate: '2026-05-12T16:20:00.000Z',
    amount: '-42.00',
    description: 'Voided purchase',
    statusCopyKey: 'TRANSACTION_STATUS_VOIDED',
    type: 'debit',
    merchant: 'Online Retailer',
  },
  {
    transactionId: 90006,
    createdDate: '2026-05-10T08:00:00.000Z',
    amount: '75.50',
    description: 'Refund',
    statusCopyKey: 'TRANSACTION_STATUS_SETTLED',
    type: 'credit',
    merchant: 'Marketplace',
  },
];

/** Builds dashboard recent-transactions state for a dev-menu override mode. */
export function dashboardRecentTransactionsDevState(
  mode: DashboardRecentTransactionsDevMode
): DashboardRecentTransactionsState {
  switch (mode) {
    case 'loading':
      return { transactions: [], hasMore: false, loading: true, error: false };
    case 'empty':
      return { transactions: [], hasMore: false, loading: false, error: false };
    case 'error':
      return { transactions: [], hasMore: false, loading: false, error: true };
    case 'list':
      return {
        transactions: _MOCK_TRANSACTIONS.slice(0, 3),
        hasMore: false,
        loading: false,
        error: false,
      };
    case 'list-see-all':
      return {
        transactions: [..._MOCK_TRANSACTIONS],
        hasMore: true,
        loading: false,
        error: false,
      };
  }
}
